export default __webpack_public_path__ + "8a0b948411e844a9751b9d41f6414243.webp";